
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import { useRouter } from '@/routing/router'
import useAppState from '@/composables/ui/ui'
import { PostsRoot } from '@/composables/post/postList'
import useConfiguration from '@/composables/configuration/configuration'
import APremium from '@/components/Ui/Badge/Premium.vue'

export default defineComponent({
  name: 'PostAuthor',
  components: { APremium, AButton },
  props: {
    postRoot: {
      type: PostsRoot,
      required: true,
    },
    showAuthorAbove: {
      type: Boolean,
      default: false,
    },
    allowShowNew: {
      type: Boolean,
      default: false,
    },
    isMinePost: {
      type: Boolean,
      default: false,
    },
    hideUserBlog: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const author = props.postRoot.post?.author
    return {
      author,
      ...useConfiguration(),
      ...useRouter(),
      ...useAppState(),
    }
  },
})
